// components/shared/reviews/ReviewsList.tsx
import { Review } from "../../../types/features/Review";
import TableList, { SelectAction } from "../../ui/TableList";
import ReviewRow from "./ReviewRow";

interface ReviewsListProps {
  reviews: Review[];
  onAction: (review: Review) => void;
  onSelectReviews?: (selectedReviews: Review[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function ReviewsList({
  reviews,
  onAction,
  onSelectReviews,
  selectable = false,
  selectActions,
}: ReviewsListProps) {
  const columns = [
    { header: "Utilisateur", className: "w-2/5" },
    { header: "Avis", className: "w-1/3" },
    { header: "Plateforme", className: "hidden sm:table-cell w-1/6" },
    { header: "Date", className: "hidden md:table-cell w-1/6" },
    { header: "Statut", className: "hidden lg:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={reviews}
      columns={columns}
      getId={(review) => review.id}
      onAction={onAction}
      onSelectItems={onSelectReviews}
      selectable={selectable}
      emptyMessage="Aucun avis trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(review, isSelected, onSelect) => (
        <ReviewRow
          key={review.id}
          review={review}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}
